import React,{useEffect, useState} from 'react'
import { OverlayTrigger ,Tooltip} from 'react-bootstrap'
import { ButtonDropdown, DropdownMenu, DropdownToggle,  } from 'reactstrap'
import { CloseIcon, SwapGrayIcon, SwapIcon } from '../../../assets/images'
import { RadioContainer } from '../../commons'
import { RadioTypes } from '../../../commonTypes/universalTypes'
export const SHORTING_RADIO_OPTIONS: RadioTypes[] = [
     {
    id: "default",
    _id:"default",
    name: "Recently Added",
  },
  {
    id: "target_date_asc",
    _id:"asc",
    name: "Target End Date - Ascending",
  },
  {
    id: "target_date_desc",
    _id:"desc",
    name: "Target End Date - Descending",
    },
   {
    id: "employee_name_asc",
    _id:"asc",
    name: "Employee Name - A to Z",
  },
  {
    id: "employee_name_desc",
    _id:"desc",
    name: "Employee Name - Z to A",
  },
]
type AppProps = {
  targetDateValue: string;
  setTargetDateValue:React.Dispatch<React.SetStateAction<string>>;
  employeeNameValue: string;
  setEmployeeNameValue: React.Dispatch<React.SetStateAction<string>>;
  targetDate: string;
  employeeName: string;
  setTargetDate: React.Dispatch<React.SetStateAction<string>>;
  setEmployeeName: React.Dispatch<React.SetStateAction<string>>;

  ////////////
    allSorting: string;
    setAllSorting: React.Dispatch<React.SetStateAction<string>>;
    allSortingValue: string;
    setAllSortingValue: React.Dispatch<React.SetStateAction<string>>;
}

const ManagerNewRequestSorting = ({
    targetDateValue,
    setTargetDateValue,
    employeeNameValue,
    setEmployeeNameValue,
  targetDate,
  employeeName,
  setTargetDate,
    setEmployeeName,
    allSorting,
    setAllSorting,
    allSortingValue,
  setAllSortingValue
}: AppProps) => {
    const [toggle, setToggle] = useState<boolean>(false);


    useEffect(() => {
         setAllSortingValue("default")
    },[])

    const handleSetInvoiceDateRadioValue = (radioValue: string) => {
        if (radioValue === "target_date_asc"||radioValue === "target_date_desc") {
            
            setTargetDateValue(radioValue);
            setTargetDate(radioValue)
            setEmployeeNameValue("")
            setEmployeeName("")
        }
        else {
            setTargetDateValue("");
            setTargetDate("")
            setEmployeeName(radioValue)
            
            setEmployeeNameValue(radioValue)
        }
        setAllSortingValue(radioValue)
    }
    


   
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle)
      }}
    >
 <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 250 }}
           overlay={ <Tooltip id="button-view-filter-invoice">
           Sorting
        </Tooltip>}>
        
      <DropdownToggle
        caret
        color="secondary"
        style={allSortingValue!=="default" ? { color: "#dd4433",
        border: "1px solid #dd4433",
        backgroundColor: "#fff6f5"} : {border:"1px solid#bfcbe1"}}
        outline
      >
          <img src={allSortingValue!=="default"? SwapIcon:SwapGrayIcon} alt="" />   
      </DropdownToggle>
          </OverlayTrigger>

      <DropdownMenu right>
         <div className="download-dropdown p-3" style={{minWidth:"300px"}}>

          <div className='d-flex justify-content-between align-items-center mt-0 mb-0'>
            <h5 className='text-center '>Sort By</h5>
            <div className='pointer' onClick={() => {
              setToggle(!toggle)
              }}>
              {/* <img src={CloseIcon} alt="" /> */}
            </div>

          </div> 
          <hr  className='mt-0 mb-0' />
        
        
          

          <div className='mt-2'>
            
            <div>
              <RadioContainer
                optionsList={SHORTING_RADIO_OPTIONS}
                handleSetRadioValue={handleSetInvoiceDateRadioValue}
                radioValue={allSortingValue}
                alignment="vertical"
                backGround={true}
              />
            </div> 
          </div>

        </div>

        
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default ManagerNewRequestSorting